

export class Objective {
    constructor(id, blockId, marker, entity) {
        this.id = id;
        this.blockId = blockId;
        this.targetMarker = marker;
        this.entity = entity;

        this._scope = {};
    }

    get scope() {
        return this._scope;
    }

    set scope(data) {
        this._scope = data;
    }
}
